import { render } from "./Menu.vue?vue&type=template&id=0aa9107f"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=0aa9107f&lang=css"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-video-partners-2/v2-remove_noCodeAPI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__